const cadre=require('./amenpicadre')
const samplercadre=require('./samplercadre')

const {build}=require('../../libs/qs')

function sortWithIndeces(toSort) {
    for (var i = 0; i < toSort.length; i++) {
      toSort[i] = [toSort[i], i];
    }
    toSort.sort(function(left, right) {
      return left[0] < right[0] ? -1 : 1;
    });
    toSort.sortIndices = [];
    for (var j = 0; j < toSort.length; j++) {
      toSort.sortIndices.push(toSort[j][1]);
      toSort[j] = toSort[j][0];
    }
    return toSort;
  }

function grayScale(context, canvas,themeidx,newArray,arr2,palletes) {


    try{
        let imgData = context.getImageData(0, 0, canvas.width, canvas.height);
        let pixels = imgData.data;
        for (let i = 0, n = pixels.length; i < n; i += 4) {
            const grayscale = pixels[i] * .3 + pixels[i + 1] * .59 + pixels[i + 2] * .11;
            let found
             for(let x=0;x<newArray.length;x++){
                 if(newArray[x+1]){
                    if(grayscale>=newArray[x]&&grayscale<=newArray[x+1]){
                        found=newArray[x]
                           break
                       }
                 }else{
                    found=newArray[x]
                    break

                 }


             }
             const idx1=newArray.indexOf(found)
             const palidx=arr2.sortIndices.indexOf(idx1)
          //  const nearest = getNearest(grayscale, paletteidx)
           // const index = paletteidx.indexOf(nearest)
             if (window.themeRgb && window.themeRgb[palidx]) {
                 pixels[i] = window.themeRgb[palidx].r;        // red
                 pixels[i + 1] = window.themeRgb[palidx].g;        // green
                 pixels[i + 2] = window.themeRgb[palidx].b;        // blue
             }
            //pixels[i+3]            //  is alpha
        }
        //redraw the image in black & white
        context.putImageData(imgData, 0, 0);

    }catch(e){
        console.error('grayScale error:', e);
    }

}


const getimg = (srcimg,idx,newArray,arr2,palletes)=>{
   return new Promise((resolve,reject)=>{



    const canvas=build('canvas')
    const ctx= canvas.getContext('2d')
    canvas.width=srcimg.width
    canvas.height=srcimg.height
    ctx.drawImage(srcimg,0,0,srcimg.width,srcimg.height)
    grayScale(ctx, canvas,idx,newArray,arr2,palletes) 
    
   const img = new Image()
   img.onload=()=>{
       resolve(img)
   }
   img.onerror=(e)=>{
       reject(e)
   }
   img.src=canvas.toDataURL()





})
}

const loadimage=(src)=>{
return new Promise((resolve,reject)=>{
    const srcimg = new Image()
    srcimg.onload=async()=>{
resolve(srcimg)
    }
    srcimg.onerror=(e)=>{
        reject(e)
    }
    srcimg.src=src

})
}


module.exports=(store)=>{

    // Convert themeRgb to luminance values for grayscale mapping
    const newArray = window.themeRgb.map(rgb => rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
     const arr2= sortWithIndeces(newArray)




    return new Promise(async(resolve,reject)=>{
  

        const cadreimg=await loadimage(cadre)
        const cadreimg1=await loadimage(samplercadre)       

    

            const imgs=[]
            const imgs1=[]





            // for(let i=0;i<store.palletes.length;i++){
             

                 const img =await getimg(cadreimg,0,newArray,arr2,store)
            //     imgs.push(img)
                const img1 =await getimg(cadreimg1,0,newArray,arr2,store)
            //     imgs1.push(img1)
            // }
            resolve({
                cadreimg:[img],
                samplerimg:[img1]
            })
        

        
    })
}